export default __webpack_public_path__ + "static/media/handprint-16-17-page.7a294235.png";